import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CsvFile, DateSelector, FullTable, PriceConvertor } from 'components';
import { useGlobalStyles, usePrimaryModal } from 'utils';
import { corporateTxnsBody, corporateTxnsHead, ACTION_TYPE, corporateTransactionsCsv } from './constants';
import { loadActions } from 'store';
import { TotalItems } from '../accounting/receivables/core/totalItems';

export const CorporateTxns = () => {
  const { corporateTxns } = useSelector((state) => ({
    corporateTxns: state.loads.corporateTxns,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const intervalRef = useRef(null);
  const globalClasses = useGlobalStyles();
  const info = history?.location?.state;
  const { openPrimary } = usePrimaryModal();

  useEffect(() => {
    handleGet('loading');

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(intervalRef.current);
  }, [info]);

  const renderParams = () => {
    const filteredInfo = {
      ...info,
      skip: info?.skip ? info?.skip : 0,
      limit: 100,
    };
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.viewType;
    return filteredInfo;
  };

  const handleGet = () => {
    dispatch(loadActions.getCorporateTxns(renderParams()));
  };

  return (
    <div className='payables-page-wrapper'>
      <div className='space-between'>
        <DateSelector
          startName={'startDate'}
          endName={'endDate'}
        />

        <CsvFile params={corporateTransactionsCsv} />
      </div>


      <div className={globalClasses.totalWrapper}>
        <div className={globalClasses.centerItem}>
          <p className={globalClasses.totalTitle}>Totals</p>
        </div>
        <div>
          <TotalItems
            text={<PriceConvertor price={corporateTxns?.total} />}
            count={` (${corporateTxns?.count || 0})`}
            title={'Total: '}
            color={'#E6ECF380'}
            styles={{ marginRight: 0 }}
          />
        </div>
      </div>

      <FullTable
        head={corporateTxnsHead}
        body={corporateTxnsBody(openPrimary)}
        loadingType={ACTION_TYPE}
        list={corporateTxns?.txns}
        listCount={corporateTxns?.count}
        noText={'Corporate Transaction'}
      />
    </div>
  );
};

